/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export enum FileActions {
  FETCH_HIGHLIGHTS = '[File] Fetch Highlights',
  FETCH_LAST_UPLOADED = '[File] Fetch Last Uploaded',
  SET_LOADING = '[File] Set Loading',
  SET_ERROR = '[File] Set Error',
}
